import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'
import { coordinates2d, passFilter } from '../selectors/stompunkt'
import { removeValueFromArray, mergeWithoutDuplicates } from '../utils/misc'
import pointInPolygon from 'point-in-polygon'

export default createReducer([], {

    [actions.CLEAR_SELECTION]: (state, action) => [],

    [actions.REMOVE_SELECTED]: (state, action) => removeFromSelection(state, action.id),

    [actions.TOGGLE_STOMPUNKT]: (state, action, fullState) => toggleSelection(state, action.id),

    [actions.TOGGLE_CURRENT_STOMPUNKT]: (state, action, fullState) => toggleSelection(state, fullState.currentStompunkt),

    [actions.SELECT_WITH_POLYGON]: (state, action, fullState) => addToSelection(state, stompunkterInPolygon(fullState, action.polygon))

})

function toggleSelection(selected, id) {
    return selected.includes(id)
        ? removeFromSelection(selected, id)
        : addToSelection(selected, [id])
}

function removeFromSelection(selected, id) {
	return removeValueFromArray(selected, id)
}

function addToSelection(selected, ids) {
	return mergeWithoutDuplicates(selected, ids)
}

function stompunkterInPolygon(state, polygon) {
	return Object.values(state.lightStompunkter)
		.filter((stompunkt) => passFilter(stompunkt, state.filter))
		.filter((stompunkt) => isInside(stompunkt, polygon))
		.map((stompunkt) => stompunkt.id)
}

function isInside(stompunkt, polygon) {
	return pointInPolygon(coordinates2d(stompunkt), polygon)
}


// WEBPACK FOOTER //
// ./src/reducers/selectedStompunkter.js